module.exports = __webpack_public_path__ + "static/media/9b48ce0a.jpg";